import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Decisions',
  slug: 'decisions',
  category: 'Decisions',
  date: '2025-05-16',
  image: '',
  excerpt: 'A few questions to ask yourself when posed with a tough decision.',
  body: `A few questions to ask yourself when posed with a tough decision.

Here are a few questions that might give some guidance when faced with a hard decision:

Where's the truth? Is it true?

Where's the honor? Is it fair and just to all? Would it make you feel proud? Worthy of a reputation it might give you?

Where's the beauty? Do you take delight in it?

If you feel bad about any of the answers, ask yourself, "why?" It might be a signal that something's wrong…

Another list of questions you might ask yourself if you want to tell somebody something they might not want to hear:

Is it true? If yes, proceed…

Does this person need to hear it? If yes, proceed…

Does this person need to hear it now? If yes, proceed…

Does this person need to hear it from you? If yes, proceed…`,
}

export default post
